import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg,
  Circle as _Circle
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(_Circle, { cx: "16", cy: "4", r: "1", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m18 19 1-7-6 1", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m5 8 3-3 5.5 3-2.36 3.5", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M4.24 14.5a5 5 0 0 0 6.88 6", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M13.76 17.5a5 5 0 0 0-6.88-6", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Accessibility";
const Accessibility = memo(themed(Icon));
export {
  Accessibility
};
//# sourceMappingURL=accessibility.js.map
